<template>
  <div>
    <!-- 采购详细 -->
    <el-dialog :visible.sync="dialogVisible" width="1600px" :title="$t('message.procurementDetails')">
      <div class="table">
        <ol>

          <li class="color1">NO</li>
          <!-- 订单号 -->
          <li class="flex15">{{ $t('message.orderNumber') }}</li>
          <!-- 番号 -->
          <li class="color1">{{ $t('message.mash') }}</li>
          <!-- 状态 -->
          <li class="color1">{{ $t('message.status') }}</li>
          <!-- 采购数量 -->
          <li>{{ $t('message.procurementQuantity') }}</li>
          <!-- 采购单价 -->
          <li>{{ $t('message.PurchaseUnitPrice') }}</li>
          <!-- 手续费 -->
          <li>{{ $t('message.poundage') }}</li>
          <!-- 附加服务费 -->
          <li>{{ $t('message.additionalServiceCharge') }}</li>
          <!-- 国内运费 -->
          <li>{{ $t('message.domesticFreight') }}</li>
          <!-- 单次采购总成本 -->
          <li>{{ $t('message.SinglePurchaseTotalCost') }}</li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="color1">{{ index + 1 }}</li>
          <!-- 订单号 -->
          <li class="flex15">
            <router-link :to="'/orderDetail?order_sn=' + item.order_sn" class="a-link" target="_blank">
              {{ item.order_sn }}
            </router-link>
          </li>
          <!-- 番号 -->
          <li class="color1">{{ item.sorting }}</li>
          <!-- 状态 -->
          <li class="color1">{{ item.status_name }}</li>
          <!-- 采购数量 -->
          <li>{{ item.confirm_num }}</li>
          <!-- 采购单价 -->
          <li>{{ item.confirm_price }}</li>
          <!-- 手续费 -->
          <li>{{ item.service_fee }}</li>
          <!-- 附加服务费 -->
          <li>{{ item.option_fee }}</li>
          <!-- 国内运费 -->
          <li>{{ item.confirm_freight }}</li>
          <!-- 单次采购总成本 -->
          <li>{{ item.total_fee }}</li>
        </ul>
        <div class="nodata" v-if="tableData == false">
          无数据
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      tableData: [],
    };
  },
  methods: {
    orderDetail(orderList) {
      this.tableData = orderList
      this.$forceUpdate()
      this.dialogVisible = true
    },
  }
}
</script>
<style lang='scss' scoped>
.table {
  padding: 0 20px;


  .flex3 {
    flex: 3
  }

  .flex15 {
    flex: 2;
  }

  li {
    text-align: center;
  }

  ul {
    padding: 0;

    li {
      padding: 10px 0;
    }
  }

  .nodata {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
  }
}
</style>